import { useMutation, useQuery } from "@tanstack/react-query";
import axiosConfig from "../axiosInstance";

export const useCreateSupportTicket = () =>
  useMutation({
    mutationKey: ["createSupportTicket"],
    mutationFn: async (formData) =>
      await axiosConfig.post("/merchant/create/support-ticket", formData),
  });

export const useGetSupportTickets = (params = {}) =>
  useQuery({
    queryKey: ["getSupportTickets", params],
    queryFn: async () =>
      await axiosConfig.get("/merchant/get/all/support-tickets", {
        params,
      }),
  });

export const useGetSupportTicket = (ticketId, enabled = true) =>
  useQuery({
    queryKey: ["getSupportTicket", ticketId],
    queryFn: async () =>
      await axiosConfig.get(`/merchant/get/support-ticket/${ticketId}`),
    enabled: !!ticketId && enabled,
  });
